// frontend-web/src/pages/Admin/Questions.js

import React, { useState, useEffect } from 'react';
import api from '../../api';

const Questions = () => {
  const [questions, setQuestions] = useState([]);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);

  const [form, setForm] = useState({
    text: '',
    option_a: '',
    option_b: '',
    option_c: '',
    option_d: '',
    correct: '',
    marks: 1,
    class_id: '',
    subject_id: '',
    question_type: 'objective'
  });

  // ===== GET CLASSES =====
  useEffect(() => {
    api.get('/admin/classes')
      .then(res => setClasses(res.data))
      .catch(err => console.log("Classes Fetch Error:", err));
  }, []);

  // ===== GET SUBJECTS BASED ON CLASS =====
  useEffect(() => {
    if (form.class_id) {
      api.get(`/admin/subjects?class_id=${form.class_id}`)
        .then(res => setSubjects(res.data))
        .catch(err => console.log("Subjects Fetch Error:", err));
    } else {
      setSubjects([]);
    }
  }, [form.class_id]);

  // ===== FETCH QUESTIONS =====
  const fetchQuestions = () => {
    if (!form.class_id || !form.subject_id) return;

    api.get(`/admin/questions?class_id=${form.class_id}&subject_id=${form.subject_id}`)
      .then(res => setQuestions(res.data.questions || []))
      .catch(() => setQuestions([]));
  };

  useEffect(() => {
    fetchQuestions();
  }, [form.class_id, form.subject_id]);

  // ===== ADD QUESTION =====
  const handleAdd = () => {

    if (!form.text || !form.option_a || !form.correct) {
      alert("⚠ Please fill required fields");
      return;
    }

    const payload = {
      ...form,
      class_id: Number(form.class_id),
      subject_id: Number(form.subject_id),
      correct: form.correct.toUpperCase()
    };

    api.post('/admin/questions', payload)
      .then(() => {
        alert('🎉 Question Added Successfully!');

        setForm({
          ...form,
          text: '',
          option_a: '',
          option_b: '',
          option_c: '',
          option_d: '',
          correct: '',
        });

        fetchQuestions();
      })
      .catch(err => alert(err.response?.data?.msg || 'Error adding question'));
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>📌 Manage Questions</h2>

      {/* ===== ADD QUESTION FORM ===== */}
      <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd' }}>
        <h3>Add New Question</h3>

        <select
          value={form.class_id}
          onChange={e => setForm({ ...form, class_id: e.target.value, subject_id: '' })}
        >
          <option value="">Select Class</option>
          {classes.map(cls => <option key={cls.id} value={cls.id}>{cls.name}</option>)}
        </select>

        <select
          value={form.subject_id}
          onChange={e => setForm({ ...form, subject_id: e.target.value })}
          disabled={!form.class_id}
        >
          <option value="">Select Subject</option>
          {subjects.map(sub => <option key={sub.id} value={sub.id}>{sub.name}</option>)}
        </select>

        <textarea
          placeholder="Question Text"
          value={form.text}
          onChange={e => setForm({ ...form, text: e.target.value })}
          style={{ width: '100%', margin: '10px 0' }}
        />

        {['a', 'b', 'c', 'd'].map(opt => (
          <input
            key={opt}
            placeholder={`Option ${opt.toUpperCase()}`}
            value={form[`option_${opt}`]}
            onChange={e => setForm({ ...form, [`option_${opt}`]: e.target.value })}
            style={{ display: 'block', margin: '5px 0', width: '100%' }}
          />
        ))}

        <input
          placeholder="Correct (A/B/C/D)"
          value={form.correct}
          onChange={e => setForm({ ...form, correct: e.target.value.toUpperCase() })}
          style={{ width: '120px', marginRight: '10px' }}
        />

        <input
          type="number"
          placeholder="Marks"
          value={form.marks}
          onChange={e => setForm({ ...form, marks: e.target.value })}
          style={{ width: '100px', marginRight: '10px' }}
        />

        <button onClick={handleAdd} style={{ padding: '8px 15px', cursor: 'pointer' }}>
          ➕ Add Question
        </button>
      </div>

      {/* ===== QUESTIONS LIST ===== */}
      <h3>📚 Questions List</h3>
      <div>
        {questions.length === 0 && <p>No questions found.</p>}

        {questions.map(q => (
          <div key={q.id} style={{ border: '1px solid #ccc', padding: '10px', marginBottom: '10px' }}>
            <p><strong>Q:</strong> {q.text}</p>
            <p><strong>A:</strong> {q.option_a}</p>
            <p><strong>B:</strong> {q.option_b}</p>
            <p><strong>C:</strong> {q.option_c}</p>
            <p><strong>D:</strong> {q.option_d}</p>
            <p><strong>Correct:</strong> {q.correct}</p>
            <p><strong>Marks:</strong> {q.marks}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Questions;
